export type BoardInteractionRules = {
  requireLongPress: boolean;
};

// Set this to false to open symbol hints and piece choosers with a normal
// click/tap. Keyboard interaction remains immediate in either mode.
export const BOARD_INTERACTION_RULES: BoardInteractionRules = {
  requireLongPress: false,
};

export function shouldActivateOnPointerUp({
  moved,
  pointerType,
  requireLongPress,
}: {
  moved: boolean;
  pointerType: string;
  requireLongPress: boolean;
}) {
  return !requireLongPress && pointerType !== 'mouse' && !moved;
}
